export default __webpack_public_path__ + "static/media/basket-white.36a783f2.svg";